export default class Role {
    constructor (dto) {
        this.id = 0;
        this.name = '';
        this.description = '';
        this.users = [];
        this.functionRights = [];
        this.isOrganizationAdmin = false;

        if (dto) {
            this.id = dto.id;
            this.name = dto.name;
            this.isOrganizationAdmin = dto.isOrganizationAdmin;
            this.description = dto.description;
            this.functionRights = dto.functionRightIds.map(function (id) { return { id: id, text: '' }; });
            this.users = dto.userIds.map(function (id) { return { id: id, text: '' }; });
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            IsOrganizationAdmin: this.isOrganizationAdmin,
            Description: this.description,
            FunctionRightIds: this.functionRights.map(item => parseInt(item.id)),
            UserIds: this.users.map(item => parseInt(item.id)),
        };
    }
}
